import { z } from 'zod';

export const creditTierMigrationInfoResponseSchema = z.object({
  newTier: z.object({
    annualInterestRate: z.number(),
    creditLimit: z.number(),
  }),
});
